import { useState, useRef, useEffect } from 'react';
import '../styles/views/_HouseholdRadioComponent.scss';
import { useTranslation } from '@/contexts/TranslationContext';

const CurrencyDropdown = ({ label, onSelect }) => {
  const { t } = useTranslation();
  const resolvedLabel = label || t('currency.chooseCountry');
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const menuRef = useRef(null);
  const dropdownRef = useRef(null);
  const [menuMaxHeight, setMenuMaxHeight] = useState('0px');

  const options = [
    { value: 'us', label: t('currency.usd') },
    // { value: 'uk', label: 'GBP – United Kingdom' },
    // { value: 'pk', label: 'PKR – Pakistan' },
  ];

  const handleSelect = (option) => {
    setSelected(option);
    onSelect?.(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const el = menuRef.current;
    if (!el) return;

    if (isOpen) {
      const scrollH = el.scrollHeight;
      setMenuMaxHeight(`${scrollH}px`);

      const onTransitionEnd = (e) => {
        if (e.propertyName === 'max-height') {
          setMenuMaxHeight('none');
          el.removeEventListener('transitionend', onTransitionEnd);
        }
      };
      el.addEventListener('transitionend', onTransitionEnd);
    } else {
      const currentHeight = el.scrollHeight;
      setMenuMaxHeight(`${currentHeight}px`);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => setMenuMaxHeight('0px'));
      });
    }
  }, [isOpen]);

  // recompute height on window resize while open
  useEffect(() => {
    const onResize = () => {
      if (isOpen && menuRef.current && menuMaxHeight !== 'none') {
        setMenuMaxHeight(`${menuRef.current.scrollHeight}px`);
      }
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [isOpen, menuMaxHeight]);

  return (
    <div className="dropdown-cur" ref={dropdownRef}>
      <button
        className={`dropdown-toggle-cur ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen((s) => !s)}
        aria-expanded={isOpen}
      >
        {selected ? selected.label : resolvedLabel}
        <span className="arrow" style={{ position: 'relative' }} />
      </button>

      <ul ref={menuRef} className={`dropdown-menu-cur ${isOpen ? 'show' : ''}`} style={{ maxHeight: menuMaxHeight }}>
        {options.map((option, idx) => (
          <li
            key={idx}
            className={`dropdown-item-cur ${selected?.value === option.value ? 'active' : ''}`}
            onClick={() => handleSelect(option)}
          >
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CurrencyDropdown;
